import SpiderChart from "./component";

export default SpiderChart;
